'use client';

import Link from 'next/link';
import { useSession } from 'next-auth/react';
import { usePathname } from 'next/navigation';
import { HiMiniUser, HiUserGroup, HiOutlineListBullet, HiHome } from 'react-icons/hi2';
import classnames from 'classnames';

import styles from './styles.module.scss';

import { UserComponent } from '@/components/User';
import LoadingComponent from '@/components/Loading';
import { CreateReportButtonComponent } from '@/components/Button/CreateReport';

interface MenuProps {
  className?: string;
}

function MenuMobileComponent({ className = '' }: MenuProps) {
  const { status } = useSession();

  const pathname = usePathname();

  const route = pathname.split('/')[1];
  const subRoute = pathname.split('/')[2];

  const userContent = status === 'authenticated' ? <UserComponent /> : <HiMiniUser />;

  const links = [
    {
      id: 1,
      href: '/',
      title: 'Início',
      icon: <HiHome />,
      view: true
    },
    {
      id: 2,
      href: '/centers/partners',
      title: 'Parceiros',
      icon: <HiUserGroup />,
      view: true
    },
    {
      id: 3,
      href: status === 'authenticated' ? '/user/my-reports' : '/login',
      title: 'Reportes',
      icon: <HiOutlineListBullet />,
      view: status === 'authenticated'
    },
    {
      id: 4,
      href: status === 'authenticated' ? '/user/profile' : '/login',
      title: status === 'authenticated' ? 'Perfil' : 'Entrar',
      icon: status === 'loading' ? <LoadingComponent mini /> : userContent,
      view: true
    }
  ];

  return (
    <nav
      className={classnames(styles.menuContainer, {
        [className]: className
      })}
      style={{
        display: pathname.split('/')[1] === 'report' ? 'none' : 'flex'
      }}
    >
      <CreateReportButtonComponent />
      <ul className={styles.menuContent}>
        {links.map(link => {
          return link.view ? (
            <Link href={link.href} key={link.id}>
              <li
                className={classnames(styles.button, {
                  [styles.active]: route === link.href.split('/')[1] && route !== 'user',
                  [styles.activeReports]: route === 'user' && subRoute === link.href.split('/')[2]
                })}
              >
                <span className={styles.icon}>{link.icon}</span>
                <p className={styles.text}>{link.title}</p>
              </li>
            </Link>
          ) : null;
        })}
      </ul>
    </nav>
  );
}

export default MenuMobileComponent;
